import { useCallback, useState } from "react";

// @ts-expect-error TS(7006) FIXME: Parameter 'original' implicitly has an 'any' type.
function getSmallerAncestor(original) {
  if (!original) {
    return;
  }
  const originalWidth = original.clientWidth;
  let element = original.parentElement;
  while (element && element.clientWidth >= originalWidth) {
    element = element.parentElement;
  }
  return element || null;
}

export const useScrollBoxWidth = () => {
  const [scrollWidth, setWidth] = useState(0);

  const calculateWidth: ResizeObserverCallback = (entries) => {
    setWidth(entries?.[0].contentRect.width);
  };

  const ref = useCallback((element: HTMLElement) => {
    const observer = new ResizeObserver(calculateWidth);
    if (element?.parentElement) {
      const ancestor = getSmallerAncestor(element.parentElement);
      if (ancestor) {
        observer.observe(ancestor);
      }
    }
  }, []);

  return [ref, scrollWidth] as const;
};
